import * as React from "react";
import { cn } from "@/lib/utils";

interface FormSectionDividerProps {
  title: string;
  description?: string;
  className?: string;
}

export function FormSectionDivider({ title, description, className }: FormSectionDividerProps) {
  return (
    <div className={cn("relative", className)}>
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-muted" />
      </div>
      <div className="relative flex justify-start">
        <div className="bg-background pr-6">
          <h3 className="text-base font-semibold leading-6">{title}</h3>
          {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
        </div>
      </div>
    </div>
  );
}
